import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import { ErrorMessage, Field, } from "formik";
import {
  handleKeyPressNumeric,
  handleNumericDot,
} from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { calculatePercentage } from "../../../CommonUtilities/CommonFunctions/CommonFunction";

export default function SSC(props) {
  const { years,Formik } = props;

  useEffect(() => {
  const percent = calculatePercentage(
    Formik.values.sscMarksSecured,
    Formik.values.sscTotalMarks
  );

  Formik.setFieldValue("sscPercentage", percent);
}, [Formik.values.sscMarksSecured, Formik.values.sscTotalMarks]);
  return (
    <React.Fragment>
      <div className="personal-head mt-3">
        <span> SSC or its Equivalent Qualification:</span>
      </div>
      <div className="personal-row mb-3">
        <Row className="row mb-2">
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <div className="input-div position-relative">
              <Form.Group controlId="sscBoard">
                <Form.Label className="input-lable mb-2">
                  Select Board <font color="red">*</font>
                </Form.Label>
                <Field
                  as="select"
                  className="input-field form-control"
                  name="sscBoard"
                >
                  <option value="">Select</option>
                  <option value="U1">
                    Board of Secondary Education, Andhra Pradesh
                  </option>
                  <option value="U2">CBSE</option>
                  <option value="U3">ICSE</option>
                  <option value="U4">OTHER STATE BOARD</option>
                  <option value="U205">APOSS</option>
                </Field>
                <ErrorMessage
                  name="sscBoard"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <div className="input-div position-relative">
              <Form.Group controlId="sscMedium">
                <Form.Label className="input-lable mb-2">
                  Select Medium <font color="red">*</font>
                </Form.Label>
                <Field
                  as="select"
                  className="input-field form-control"
                  name="sscMedium"
                >
                  <option value=" ">Select</option>
                  <option value="1">TELUGU</option>
                  <option value="2">URDU</option>
                  <option value="3">HINDI</option>
                  <option value="4">KANNADA</option>
                  <option value="5">ORIYA</option>
                  <option value="6">TAMIL</option>
                  <option value="7">ENGLISH</option>
                  <option value="8">SANSKRIT</option>
                </Field>
                <ErrorMessage
                  name="sscMedium"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <div className="input-div position-relative">
              <Form.Group controlId="sscFirstLanguage">
                <Form.Label className="input-lable mb-2">
                  1st Language<font color="red">*</font>
                </Form.Label>
                <Field
                  as="select"
                  className="input-field form-control"
                  name="sscFirstLanguage"
                >
                  <option value="">Select</option>
                  <option value="1">TELUGU</option>
                  <option value="2">URDU</option>
                  <option value="3">HINDI</option>
                  <option value="4">KANNADA</option>
                  <option value="5">ORIYA</option>
                  <option value="6">TAMIL</option>
                  <option value="7">ENGLISH</option>
                  <option value="8">SANSKRIT</option>
                </Field>
                <ErrorMessage
                  name="sscFirstLanguage"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <div className="input-div position-relative">
              <Form.Group controlId="sscYearOfPass">
                <Form.Label className="input-lable mb-2">
                  Year of Passing <font color="red">*</font>
                </Form.Label>
                <Field
                  as="select"
                  className="input-field form-control"
                  name="sscYearOfPass"
                >
                  <option value="">Select</option>
                  {years
                    ?.filter(
                      (year) =>
                        year !== 2026 &&
                        year !== 2025 &&
                        year !== 2024 &&
                        year !== 2023,
                    )
                    ?.map((year, i) => (
                      <option key={i} value={year}>
                        {year}
                      </option>
                    ))}
                </Field>
                <ErrorMessage
                  name="sscYearOfPass"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="sscHallTicket">
              <Form.Label className="input-lable mb-2">
                Hall Ticket No.<font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="sscHallTicket"
                className="input-field form-control"
                placeholder="Enter Hall Ticket Number"
                maxLength={15}
              />
              <ErrorMessage
                name="sscHallTicket"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="sscTotalMarks">
              <Form.Label className="input-lable mb-2">
                Total marks<font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="sscTotalMarks"
                className="input-field form-control"
                maxLength={4}
                onChange={(e) => {
                  handleKeyPressNumeric(e);
                }}
              />
              <ErrorMessage
                name="sscTotalMarks"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="sscMarksSecured">
              <Form.Label className="input-lable mb-2">
                Marks Secured<font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="sscMarksSecured"
                className="input-field form-control"
                maxLength={4}
                onChange={(e) => {
                  handleKeyPressNumeric(e);
                }}
              />
              <ErrorMessage
                name="sscMarksSecured"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="sscPercentage">
              <Form.Label className="input-lable mb-2">
                Percentage of marks(including languages)
                <font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="sscPercentage"
                className="input-field form-control"
                maxLength={4}
                readOnly
              />
              <ErrorMessage
                name="sscPercentage"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col
            xxl={3}
            xl={3}
            lg={4}
            md={6}
            sm={12}
            xs={12}
            className="mb-2 mt-2"
          >
            <Form.Group controlId="">
              <Form.Label className="input-lable mb-2">
                Have you studied English as one of your Subjects ?
                <font color="red">*</font>
              </Form.Label>
              <div className="form-border">
                <Field
                  type="radio"
                  name="isEnglishSsc"
                  value="Yes"
                  className="form-sub me-1"
                />
                Yes &nbsp;&nbsp;&nbsp;&nbsp;
                <Field
                  type="radio"
                  value="No"
                  name="isEnglishSsc"
                  className="form-sub me-1"
                />
                No &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <ErrorMessage
                name="isEnglishSsc"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}
